module.exports = __webpack_public_path__ + "static/media/plane(13).0f44e9bf.PNG";